import { render, staticRenderFns } from "./newSearchProcess.vue?vue&type=template&id=0f7a7e1f&"
import script from "./newSearchProcess.vue?vue&type=script&lang=js&"
export * from "./newSearchProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports